// extracted by mini-css-extract-plugin
export default {"newsSection":"UksNews_newsSection__M5ZI6","title":"UksNews_title__kJQBw","cardWrapper":"UksNews_cardWrapper__UpzGE","buttonWrapper":"UksNews_buttonWrapper__0OdYY"};